var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuestionshero(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 372,
    height: 419,
    viewBox: "0 0 372 419",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M291.764 141.673c-32.321-18.892-59.053-1.213-63.782 39.504-.821 7.079 4.533 16.388 11.021 20.182l105.482 61.642c6.488 3.794 11.842.743 11.06-7.275-4.729-46.271-31.461-95.201-63.781-114.053z",
    fill: "url(#y3dpes3jia)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M327.794 88.753c0 28.122-16.258 41.421-36.307 29.687-20.01-11.695-36.268-43.963-36.268-72.085 0-28.122 16.258-41.42 36.307-29.687 20.049 11.695 36.268 44.002 36.268 72.085z",
    fill: "url(#1npll7fa2b)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M307.396 129.939c-32.32-18.891-59.052-1.212-63.781 39.504-.821 7.079 4.533 16.388 11.021 20.182l105.482 61.642c6.488 3.794 11.842.743 11.06-7.275-4.729-46.27-31.461-95.201-63.782-114.053z",
    fill: "url(#mvhrsmmc7c)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M343.431 77.02c0 28.122-16.258 41.42-36.307 29.686-20.01-11.695-36.269-43.963-36.269-72.085 0-28.122 16.259-41.42 36.308-29.686 20.049 11.694 36.268 44.001 36.268 72.084z",
    fill: "url(#pycbkgxlzd)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M75.634 143.246 2.864 101.2v37.939l72.809 42.046-.04-37.939z",
    fill: "url(#x0em44ndie)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.637 122.477c0 3.129-1.837 4.576-4.143 3.286-2.267-1.33-4.142-4.929-4.142-8.058 0-3.129 1.836-4.576 4.142-3.285 2.306 1.33 4.143 4.928 4.143 8.057z",
    fill: "#00EDD5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "m21.387 121.304 23.8 13.729v5.319l-23.8-13.729v-5.319zM21.504 132.021l46.625 26.948v5.32L21.504 137.34v-5.319z",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "m218.609 182.512 73.123 42.242V382.34l-73.123-42.203V182.512z",
    fill: "url(#l2ass964kf)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "m279.54 235.315-73.161-42.242v157.585l73.122 42.242.039-157.585zm-49.321-18.383 24.426 14.08v6.258l-24.426-13.885v-6.453z",
    fill: "url(#6sygq0v8pg)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "m213.449 292.928 58.74 33.911v5.319l-58.74-33.911v-5.319zM217.594 305.678l50.533 29.179v5.319l-50.533-29.178v-5.32z",
    fill: "#fff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M259.298 279.669c0-12.477-7.309-26.832-16.298-32.034-8.989-5.202-16.297.704-16.297 13.181 0 12.477 7.308 26.832 16.297 32.034 8.989 5.202 16.298-.704 16.298-13.181z",
    fill: "#00EDD5"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "m119.094 72.33 73.122 42.242v157.586l-73.122-42.242V72.33z",
    fill: "url(#vi29qvmaih)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "m180.025 125.25-73.162-42.242v157.586l73.123 42.241.039-157.585zm-49.322-18.383 24.427 14.08v6.259l-24.427-13.886v-6.453z",
    fill: "url(#gkdi2fuf5i)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "m113.938 182.707 58.74 33.91v5.32l-58.74-33.911v-5.319zM118.043 195.497l50.494 29.178v5.319l-50.533-29.178.039-5.319z",
    fill: "#fff"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M159.778 169.487c0-12.477-7.308-26.832-16.297-32.034-8.989-5.202-16.297.704-16.297 13.181 0 12.477 7.308 26.832 16.297 32.034 8.989 5.202 16.297-.704 16.297-13.181z",
    fill: "#00EDD5"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M159.355 311.517 43.047 244.322l.039 60.664 106.029 61.25 10.279 15.215-.039-69.934z",
    fill: "url(#pz319w6htj)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M96.97 208.805 9.136 158.326l.03 45.572 80.07 46.014 7.762 11.429-.03-52.536z",
    fill: "url(#eh11qja3lk)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M30.656 267.985v-16.466l43.89 25.345v16.466l-43.89-25.345zM.172 177.812v-14.111l37.655 21.72v14.111L.172 177.812z",
    fill: "#00EDD5"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "m129.454 309.014-25.481-14.706v5.319l25.481 14.707v-5.32zM84.447 215.194l-19.724-11.183v4.045l19.724 11.183v-4.045zM129.454 319.692l-49.126-28.357v5.32l49.126 28.356v-5.319zM84.45 223.34l-36.759-21.121v3.962l36.759 21.121v-3.962zM129.452 330.331 69.969 295.95v5.32l59.522 34.38-.039-5.319zM84.42 231.403l-44.799-25.6v3.961l44.828 25.6-.03-3.961z",
    fill: "#fff"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M135.746 318.206c0 5.006 2.971 10.756 6.605 12.868 3.635 2.112 6.605-.235 6.605-5.241 0-5.007-2.97-10.757-6.605-12.869-3.673-2.112-6.644.235-6.605 5.242z",
    fill: "#00EDD5"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M48.977 57.667c2.345 1.33 4.22 4.616 4.22 7.314v11.93l7.895 4.537c2.345 1.33 4.221 4.615 4.221 7.314s-1.876 3.794-4.22 2.464l-7.895-4.537v11.93c0 2.698-1.876 3.793-4.221 2.463s-4.221-4.615-4.221-7.314V81.84l-7.895-4.537c-2.344-1.33-4.22-4.615-4.22-7.314s1.876-3.794 4.22-2.464l7.895 4.537V60.13c0-2.698 1.876-3.794 4.22-2.464z",
    fill: "url(#wfui4blygl)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "y3dpes3jia",
    x1: 425.125,
    y1: 110.859,
    x2: 293.768,
    y2: 206.604,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "1npll7fa2b",
    x1: 358.217,
    y1: 18.858,
    x2: 226.86,
    y2: 114.604,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mvhrsmmc7c",
    x1: 440.758,
    y1: 99.125,
    x2: 309.401,
    y2: 194.871,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pycbkgxlzd",
    x1: 373.854,
    y1: 7.124,
    x2: 242.497,
    y2: 102.87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "x0em44ndie",
    x1: 47.462,
    y1: 126.972,
    x2: 31.023,
    y2: 155.429,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l2ass964kf",
    x1: 297.642,
    y1: 208.831,
    x2: 206.974,
    y2: 365.789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "6sygq0v8pg",
    x1: 285.413,
    y1: 219.372,
    x2: 194.745,
    y2: 376.33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "vi29qvmaih",
    x1: 198.123,
    y1: 98.642,
    x2: 107.456,
    y2: 255.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gkdi2fuf5i",
    x1: 185.897,
    y1: 109.307,
    x2: 95.23,
    y2: 266.265,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pz319w6htj",
    x1: 133.991,
    y1: 287.222,
    x2: 73.906,
    y2: 334.23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eh11qja3lk",
    x1: 77.815,
    y1: 190.554,
    x2: 32.621,
    y2: 226.098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "wfui4blygl",
    x1: 57.136,
    y1: 72.917,
    x2: 36.662,
    y2: 89.063,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionshero);
export default __webpack_public_path__ + "static/media/Questions hero.3a39e1bb5c5261f04052139ac85817ff.svg";
export { ForwardRef as ReactComponent };